export default __webpack_public_path__ + "static/media/cat_jachthaven.36429e5b.svg";